<!-- Heading Row -->
<div class="container-fluid">
  <div class="row my-2">
    <div class="col-lg-6">
      <img class="img-fluid rounded" src="/assets/blue-locks.jpg" height="400" width="900" alt="">
    </div>
    <!-- /.col-lg-8 -->
    <div class="col-lg-6">
      <h1>Conservatorship Accounting Portal</h1>
      <div *ngIf="!user">
        <p>Welcome to the Conservatorship Accounting Portal. Click on the button below to Sign-in or Register</p>
        <a class="btn btn-primary btn-lg" href="#" (click)='login($event)'>Sign-in</a>
      </div>
    </div>
  </div>
   <div class="card text-white bg-secondary my-4 text-center" back>
    <div class="card-body p-4  cap-carousel">
        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators">
            <li data-target="#carouselExampleIndicators" *ngFor="let ann of announcements; index as i;" data-slide-to="i"></li>
          </ol>
          <div class="carousel-inner" role="listbox">
            <div class="carousel-item active p-1" *ngFor="let ann of announcements; index as i;" [ngClass]="{'active' : i === 0 }">
              <b>{{ann.title}}</b>
              <p>{{ann.content}}</p>
            </div>
          </div>
          <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev" [ngClass]="scrollInvisiblity()">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next" [ngClass]="scrollInvisiblity()">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>    
  </div>

  <ng-template #template id="exampleModal" class="modal-lg">
      <div class="modal-body">
          <iframe [src]="videoUrl" width="100%" height="500px" style="border: 0;" allow="autoplay; fullscreen" allowfullscreen></iframe>         
      </div>   
  </ng-template>
    
  <!-- Content Row -->
  <div class="row">    
    <!-- /.col-md-4 -->
    <div class="col-md-2 mb-4">
    </div>
    <div class="col-md-4 mb-4">
      <div class="card h-100">
        <div class="card-body">          
          <h2 class="card-title">Get Started</h2>

          <div class="row">
            <div class="col-md-8">
               <p class="card-text">
                To learn more about the Conservatorship Accounting Portal, please view the following video
                </p>
            </div>

            
            <div class="col-md-4">              
              <div class="videoContainer">
                <img [src]="thumbnailUrl" (click)="openModal(template)" style="max-height:100%;max-width:100%"/>                
                <img src="assets/img/playbutton.png" alt="play" class="playBtn" (click)="openModal(template)">
              </div>              
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="col-md-4 mb-4">
      <div class="card h-100">
        <div class="card-body">
          <h2 class="card-title">Contact Us</h2>
          <p class="card-text">
          Please email <a href = "mailto: ProbateCAP@occourts.org">ProbateCAP@occourts.org</a> if you experience any issues accessing the portal
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-2 mb-4">
    </div>
  </div>
  <!-- /.container -->
  
</div>
<!-- Footer -->
<footer class="py-3 bg-dark">
  <div class="col-lg-12 text-muted small">© 2024 Superior Court of Orange County <span class="float-right">{{this.version}}</span></div>      
  <div class="container"></div>
  <!-- /.container -->
</footer>
